import { TmrBaseResource } from 'stylewhere/api'

/**
 * Use this for non encoding related production order rows.
 * For encoding related production order rows please use EncodingProductionOrderRows.
 */
export class ProductionOrderRows extends TmrBaseResource {
  static endpoint = 'api/v1/productionOrderRows'
}
